<div class="fc-ag-loading-mask-holder">
    <ng-template #viewContainer></ng-template>
</div>